// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"links_linkItem__eaZxc","innerLink":"links_innerLink__WXBM_","disabled":"links_disabled__oFTaB"};